/**
 * Stick the header to the top of the page after a certain scroll amount
 */
export default {
  mainHeader: null,
  headerHeight: null,

  //set scrolling variables
  scrolling: false,
  scrollDelta: 10,
  scrollOffset: 150,

  init() {
    this.mainHeader = document.querySelector('.js-auto-hide-header');
    this.headerHeight = this.getHeight(this.mainHeader);

    this.mainHeader.addEventListener('click', event => {
      // open primary navigation on mobile
      if ( event.target.classList.contains('.nav-trigger') ) {
          event.preventDefault();
          this.mainHeader.classList.toggle('nav-open');
      }
    });

    window.addEventListener('scroll', () => {
      if( !this.scrolling ) {
        this.scrolling = true;
        (!window.requestAnimationFrame) ? setTimeout(this.autoHideHeader.bind(this), 250) : requestAnimationFrame(this.autoHideHeader.bind(this));
      }
    });

    window.addEventListener('resize', () => {
      this.headerHeight = this.getHeight(this.mainHeader);
    });
  },

  autoHideHeader() {
    const currentTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    this.checkNavigation(currentTop);

    this.previousTop = currentTop;
    this.scrolling = false;
  },

  checkNavigation(currentTop) {
    //there's no secondary nav or secondary nav is below primary nav
    if (this.previousTop - currentTop > this.scrollDelta) {
      //if scrolling up...
      this.mainHeader.classList.remove('is-hidden');
    } else if( currentTop - this.previousTop > this.scrollDelta && currentTop > this.scrollOffset) {
      //if scrolling down...
      this.mainHeader.classList.add('is-hidden');
    }
  },

  getHeight(el) {
    return parseFloat(getComputedStyle(el, null).height.replace("px", ""))
  },
}
